import { Component } from '@angular/core';

@Component({
  selector: 'app-exchange-return',
  standalone: true,
  imports: [],
  templateUrl: './exchange-return.component.html',
  styleUrl: './exchange-return.component.scss'
})
export class ExchangeReturnComponent {

}
